export const MARKET_TYPES = {
  main: 0,
  sidePerfectPair: 1,
  side21plus3: 2,
};

export const SIDE_BET_TYPE_NAMES = {
  1: 'sidePerfectPair',
  2: 'side21plus3',
};

export const DECISION_ACTION_TYPES = {
  Hit: 0,
  Stand: 1,
  Double: 2,
  Split: 3,
  Surrender: 4,
  Insurance: 5,
};

export const DECISION_ACTION_TYPES_NAMES_INITIAL = {
  0: 'isHit',
  1: 'isStand',
  2: 'isDouble',
  3: 'isSplit',
  4: 'isSurrender',
  5: 'isInsurance',
};

export const BET_TYPES_NAMES = {
  0: 'main',
  1: 'sidePerfectPair',
  2: 'side21plus3',
};

export const DECISION_ACTIONS_FOR_VIEW = [
  {
    betType: DECISION_ACTION_TYPES.Split,
    icon: 'split-cards',
    isMin: true,
  },
  {
    betType: DECISION_ACTION_TYPES.Stand,
    icon: 'stop-card',
  },
  {
    betType: DECISION_ACTION_TYPES.Hit,
    icon: 'add-card',
  },
  {
    betType: DECISION_ACTION_TYPES.Double,
    icon: 'thin-double',
    isMin: true,
  },
];

export const ReBetTypes = {
  reBet: 0,
  doubleReBet: 1,
};

export const BET_STATUS = {
  Lose: 0,
  Win: 1,
};

export const BET_ACTION_TYPES = {
  Main: 0,
  Split: 1,
  Double: 2,
  Insurance: 3,
};

export const BET_ACTION_TYPE_NAMES = {
  0: 'Main',
  1: 'Split',
  2: 'Double',
  3: 'Insurance',
};
